import {makeGetSolusPortalUrl} from 'main/factories/usecases';
import {useState} from 'react';
import {useSolusPortalUrlStore} from './store';

export const useGetSolusPortal = () => {
	const solusPortalUrl = useSolusPortalUrlStore(state => state.solusPortalUrl);
	const setSolusPortalUrl = useSolusPortalUrlStore(state => state.setSolusPortalUrl);
	const [loading, setLoading] = useState(false);

	const handleOpenSolusPortal = async () => {
		if (solusPortalUrl) {
			window.open(solusPortalUrl);
		} else if (!loading) {
			setLoading(true);
			try {
				const response = await makeGetSolusPortalUrl().get();
				window.open(response.url);
				setSolusPortalUrl(response.url);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
			} finally {
				setLoading(false);
			}
		}
	};
	return {
		openLink: handleOpenSolusPortal,
		loading,
	};
};
